import axios from 'axios';

const API_BASE = '/api/auth/kiosk';

export const authKioskService = {
  verifyPin: async (pin) => {
    const response = await axios.post(`${API_BASE}/verify-pin`, { pin });
    return response.data;
  },

  activateAccount: async ({ pin, email, password }) => {
    const response = await axios.post(`${API_BASE}/activate-account`, { pin, email, password });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await axios.post(`${API_BASE}/forgot-password`, { email });
    return response.data;
  },

  resetPassword: async ({ token, password }) => {
    const response = await axios.post(`${API_BASE}/reset-password`, { token, password });
    return response.data;
  },
};
